import { createPermission } from '@backstage/plugin-permission-common';

export const groupSlackChannelsPermission = createPermission({
  name: 'hone.integrations.slack.channels.manage',
  attributes: {},
});
